<template>
  <g>
    <border stroke="#28d094" />
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      x="6"
      y="8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.63"
        y="4.22998"
        width="6.99784"
        height="1.3"
        rx="0.65"
        transform="rotate(45 1.63 4.22998)"
        fill="#28D094"
      />
      <rect
        x="14.1427"
        y="1.61586"
        width="12.0006"
        height="1.3"
        rx="0.65"
        transform="rotate(135 14.1427 1.61586)"
        fill="#28D094"
      />
    </svg>
  </g>
</template>

<script>
  import Border from './_border';
  export default {
    components: {
      Border
    }
  };
</script>
